import {connect} from 'react-redux';

import {HandlerOf, PredicateOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {CellsConversationsDragItem} from '../../../helpers/conversationCellHelpers';
import {wrapActionCreator} from '../../../helpers/reduxHelpers';
import {TeammateModel} from '../../../models/api/teammateModel';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
  WorkspaceDisplaySectionTrackingTypesEnum,
} from '../../../services/tracking';
import {AppState} from '../../../store/appState';
import {Dispatch} from '../../../store/appStore';
import {
  assignToTeammateAction,
  canAssignToTeammateAction,
} from '../../../store/data/conversations/assigneeConversationsActions';
import {makeGetOnlineStatus} from '../../../store/data/teammates/onlineTeammatesSelectors';
import {WorkspaceDropReorderTeammateHandler} from '../../../store/data/workspace/reorder/types';
import {reorderTeammateInTeammatesWorkspaceAsyncAction} from '../../../store/data/workspace/workspaceActions';
import {WorkspaceTeammateItemContainerBase} from './workspaceTeammateItemContainerBase';

/*
 * Props.
 */

interface WorkspaceTeammateItemContainerProps {
  teammate: TeammateModel;
}

/*
 * Selectors.
 */

function getTeammateId(_state: AppState, props: WorkspaceTeammateItemContainerProps) {
  return props.teammate.id;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<WorkspaceTeammateItemContainerProps>()(() => ({
  onlineStatus: makeGetOnlineStatus(getTeammateId),
}));

function mapDispatchToProps(dispatch: Dispatch, _props: WorkspaceTeammateItemContainerProps) {
  return {
    reorderTeammateInTeammatesWorkspace: wrapActionCreator(
      dispatch,
      reorderTeammateInTeammatesWorkspaceAsyncAction,
    ),
    canAssignToTeammate: wrapActionCreator(dispatch, canAssignToTeammateAction),
    assignToTeammate: wrapActionCreator(dispatch, assignToTeammateAction),
  };
}

/** For use in displaying teammates in the teammates' assigned conversations workspace. Not to be used when editing the workspace. */
export const WorkspaceTeammateItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const {onlineStatus} = stateProps;
    const {teammate} = ownProps;

    const canConversationsDrop: PredicateOf<CellsConversationsDragItem> = (options) =>
      dispatchProps.canAssignToTeammate(options.conversationIds, teammate, options.findConversationInboxIds);

    const onConversationsDrop: HandlerOf<CellsConversationsDragItem> = (options) => {
      dispatchProps.assignToTeammate(options.conversationIds, teammate.id);
    };

    const onDropReorderTeammate: WorkspaceDropReorderTeammateHandler = (dropArgs) => {
      trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_REORDER, {
        section: WorkspaceDisplaySectionTrackingTypesEnum.TEAMMATES,
      });
      dispatchProps.reorderTeammateInTeammatesWorkspace(dropArgs);
    };

    return {
      ...ownProps,
      onlineStatus,
      canBeHidden: true,
      shouldHideMoreMenu: false,
      isEditingWorkspace: false,
      onDropReorderTeammate,
      canConversationsDrop,
      onConversationsDrop,
    };
  },
)(WorkspaceTeammateItemContainerBase);
